import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store.ts'
import { getCurrentQuarterRange } from '../../utils/time.ts'

interface IdeaListInputState {
  category: string
  firm: string
  contributor: string
  dateRange: [string | null, string | null]
  onlyMyIdea: boolean
  showLiquidatedIdeas: boolean
  onlyPremiumLeague: boolean
  bookId: string
}

export const ideaListInputSlice = createSlice({
  name: 'ideaListInput',
  initialState: {
    category: '',
    firm: '',
    contributor: '',
    dateRange: getCurrentQuarterRange() as [string, string],
    onlyMyIdea: false,
    showLiquidatedIdeas: false,
    onlyPremiumLeague: false,
    bookId: '',
  } as IdeaListInputState,
  reducers: {
    setIdeaListCategory(state, action) {
      state.category = action.payload
    },
    setIdeaListFirm(state, action) {
      state.firm = action.payload
    },
    setIdeaListContributor(state, action) {
      state.contributor = action.payload
    },
    setIdeaListDateRange(state, action) {
      state.dateRange = [
        action.payload?.[0] ? action.payload[0] : null,
        action.payload?.[1] ? action.payload[1] : null,
      ]
    },
    toggleOnlyMyIdea(state, action) {
      state.onlyMyIdea = action.payload
    },
    toggleShowLiquidatedIdeas(state, action) {
      state.showLiquidatedIdeas = action.payload
    },
    toggleOnlyPremiumLeague(state, action) {
      state.onlyPremiumLeague = action.payload
    },
    setBookId(state, action) {
      state.bookId = action.payload
    },
  },
})

export const selectIdeaListInput = (state: RootState) => state.ideaListInput

export const {
  setIdeaListCategory,
  setIdeaListFirm,
  setIdeaListContributor,
  setIdeaListDateRange,
  toggleOnlyMyIdea,
  toggleShowLiquidatedIdeas,
  toggleOnlyPremiumLeague,
  setBookId,
} = ideaListInputSlice.actions
